<template>
  <nav v-if="pages > 1" class="pager" aria-label="分页">
    <button type="button" :disabled="page <= 1" @click="go(page - 1)">上一页</button>
    <span>第 {{ page }} / {{ pages }} 页 · 共 {{ total }} 条</span>
    <button type="button" :disabled="page >= pages" @click="go(page + 1)">下一页</button>
  </nav>
</template>

<script>
export default {
  name: 'ListPager',
  props: {
    page: { type: Number, default: 1 },
    pages: { type: Number, default: 1 },
    total: { type: Number, default: 0 }
  },
  methods: {
    go(n) {
      if (n < 1 || n > this.pages || n === this.page) return
      this.$emit('update:page', n)
      this.$emit('change', n)
    }
  }
}
</script>

<style scoped>
.pager {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
  font-size: 13px;
  color: #4e5969;
}
.pager button {
  border: 1px solid #e5e6eb;
  background: #fff;
  border-radius: 4px;
  padding: 4px 10px;
  font: inherit;
  cursor: pointer;
}
.pager button:disabled {
  opacity: 0.45;
  cursor: default;
}
</style>
